import React from 'react';
import { withAppStorage } from '../utils/appStorage';
import HeaderCart from '../components/HeaderCart';
import { Query } from 'react-apollo';
import { GET_CART } from '../pages/CartPage';

export default withAppStorage(function HeaderCartController({ appStorage, appStorageData }) {
    if (appStorageData.cartId) {
        return (<Query
            query={GET_CART}
            variables={{
                id: appStorageData.cartId
            }}
        >
            {({ data, loading, error }) => <HeaderCart
                cartItemCount={(data && data.cart && data.cart.products.length) || 0}
            />}
        </Query>);
    }

    return (<HeaderCart
        cartItemCount={0}
    />);
});
